export const COLORS = {
    PRIMARY: '#4EAC6D',
    PRIMARY_LIGHT: '#A0D9B3',
}

export const SELECTOR_STYLE = {
    control: (provided, state) => ({
        ...provided,
        width: '100%',
        borderColor: state.isFocused ? COLORS.PRIMARY : provided.borderColor,
        borderWidth: 2,
        boxShadow: state.isFocused ? '0 0 0 1px ' + COLORS.PRIMARY : provided.boxShadow,
        '&:hover': {
            borderColor: COLORS.PRIMARY,
            boxShadow: '0 0 0 1px ' + COLORS.PRIMARY,
        },
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor:
            state.isSelected ?
                COLORS.PRIMARY
                // : state.isFocused ? COLORS.PRIMARY_LIGHT
            :   'white',
        color:
            state.isDisabled ? '#ccc'
            : state.isSelected ? 'white'
            : 'black',
        cursor: state.isDisabled ? 'not-allowed' : 'default',
        '&:hover': {
            backgroundColor: state.isDisabled ? 'white' : COLORS.PRIMARY_LIGHT,
        },
        padding: '8px 12px',
    }),
    // singleValue: (provided) => ({
    //   ...provided,
    //   color: COLORS.PRIMARY,
    // }),
    multiValue: provided => ({
        ...provided,
        backgroundColor: COLORS.PRIMARY,
    }),
    multiValueLabel: provided => ({
        ...provided,
        color: 'white',
        fontSize: '16px',
        backgroundColor: COLORS.PRIMARY,
        width: '150px',
    }),
    multiValueRemove: provided => ({
        ...provided,
        color: 'white',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: state.isFocused ? COLORS.PRIMARY : provided.color,
        '&:hover': { color: COLORS.PRIMARY },
    }),
}
